import styled from 'styled-components';
import {dFlexColumn} from '../../../../globalVariables/GlobalFlex';
import {WHITE} from '../../../../globalVariables/GlobalVariables';
import {popUpTop} from '../../../../component/newPopup/topPopup/TopPopup.css';

export const assigningEventsPop = styled.div`
    ${popUpTop}{
        display: none;
    }
`;

export const container = styled.div`
    ${dFlexColumn}
    height: calc(100% - 70px);
    background: ${WHITE};
    position: relative;
`;
